import $ from '@nuskin/nuskinjquery';
import {shopModule} from '../module.js';
import {nuskin, events} from '@nuskin/ns-util';

shopModule.directive('nsGeoLocation', ['nsUtil', function(nsUtil) {
    return {
        require: 'ngModel',
        link: function(scope, ele, attr) {
            let config = nuskin.configuration;
            let mapsApiKey = config.checkout.googleMapsApi;
            let model = scope.$eval(attr.ngModel.substr(0, attr.ngModel.lastIndexOf(".")));
            let autocomplete;
            let util = nsUtil;

            window.initAutocomplete = function() {
                if (mapsApiKey != null || mapsApiKey != undefined) {
                    let googleApiId = $("#googleApi");
                    let googleScripts = $('script[src^="https://maps.googleapis.com"]').length;
                    if (googleApiId.length < 1) {
                        buildGoogleMapsScriptTag();
                    }
                    if (googleScripts < 5) {
                        setTimeout(function() {
                            if (typeof google === "object" && autocomplete == undefined) {
                                // eslint-disable-next-line no-undef
                                autocomplete = new google.maps.places.Autocomplete(ele[0], {types: ['address']});
                                autocomplete.setFields(['address_component']);
                                autocomplete.addListener('place_changed', fillInAddress);
                            }
                        }, 1000);
                    } else {
                        if (typeof google === "object" && autocomplete == undefined) {
                            // eslint-disable-next-line no-undef
                            autocomplete = new google.maps.places.Autocomplete(ele[0], {types: ['address']});
                            autocomplete.setFields(['address_component']);
                            autocomplete.addListener('place_changed', fillInAddress);
                        }
                    }
                    ele[0].placeholder =  "";
                }
            };

            function getCountyDropdownOptions(dropdownValue) {
                $('#new_form_shippingCounty option').each(function() {
                    let dropdownValueUppercase = dropdownValue.toUpperCase();
                    if ($(this).text() === dropdownValueUppercase) {
                        model.shippingCounty = $(this).val();
                    }
                });
            }

            function checkStateValidity(dropdownId, value, formType, customer) {
                let valueExists = 0;
                $(dropdownId + ' option').each(function() {
                    let dropdownValueUppercase = value.toUpperCase();
                    if ($(this).text() === dropdownValueUppercase || $(this).val() === dropdownValueUppercase) {
                        valueExists += 1;
                        if (formType === "shipping") {
                            model.shippingState = $(this).val();
                        } else if (formType === "payment") {
                            model.region = $(this).val();
                        }

                    }
                });

                if (valueExists < 1) {
                    util.clearForm(scope.forms.addShippingForm, model);
                    util.clearForm(scope.forms.editShippingForm, model);
                    util.clearForm(scope.forms.addPaymentForm, model);
                    util.clearForm(scope.forms.editPaymentForm, model);

                    if (formType === "shipping") {
                        model.shippingAddressName = customer.name;
                    } else if (formType === "payment") {
                        model.paymentName = customer.name;
                        model.paymentNumber = customer.paymentNumber;
                        model.expMonth = customer.expireMonth;
                        model.expYear = customer.expireYear;
                    }

                    events.publish(events.errors.INVALID_SEARCH_ADDRESS, ele);
                }
            }

            function fillInAddress() {
                events.publish(events.shop.NEW_GOOGLE_MAPS_SEARCH);

                let componentForm = {
                    street_number: 'short_name',
                    route: 'long_name',
                    locality: 'long_name',
                    administrative_area_level_1: 'short_name',
                    administrative_area_level_2: 'long_name',
                    country: 'long_name',
                    postal_code_prefix: 'short_name',
                    postal_code: 'short_name'
                };

                let place = autocomplete.getPlace();
                let customer = {};
                let isShippingForm = false;
                let isPaymentForm = false;
                let addressIncomplete = false;
                if (scope.sections.shipping.adding || scope.sections.shipping.editing) {
                    isShippingForm = true;
                    customer.name = model.shippingAddressName;
                    customer.phone = model.shippingPhone;
                    customer.email = model.shippingEmail;
                    customer.saveShipping = model.saveShipping;
                    customer.defaultShipping = model.defaultShipping;
                    customer.shippingInstructions = model.shippingInstructions;
                } else if (scope.sections.payment.adding || scope.sections.payment.editing) {
                    isPaymentForm = true;
                    customer.name = model.paymentName;
                    customer.paymentNumber = model.paymentNumber;
                    customer.expireMonth = model.expMonth;
                    customer.expireYear = model.expYear;
                }

                util.clearForm(scope.forms.addShippingForm, model);
                util.clearForm(scope.forms.editShippingForm, model);
                util.clearForm(scope.forms.addPaymentForm, model);
                model.shippingAddressName = customer.name;
                model.shippingPhone = customer.phone;
                model.shippingEmail = customer.email;
                model.saveShipping = customer.saveShipping;
                model.defaultShipping = customer.defaultShipping;
                model.shippingInstructions = customer.shippingInstructions;
                model.paymentName = customer.name;
                model.paymentNumber = customer.paymentNumber;
                model.expMonth = customer.expireMonth;
                model.expYear = customer.expireYear;

                for (let i = 0; i < place.address_components.length; i++) {
                    let addressType = place.address_components[i].types[0];
                    if (componentForm[addressType]) {
                        let val = place.address_components[i][componentForm[addressType]];
                        componentForm[addressType] = val;
                    }
                }

                if (componentForm.street_number !== 'short_name') {
                    model.shippingAddress1 = componentForm.street_number + ' ' + componentForm.route;
                    model.address1 = componentForm.street_number + ' ' + componentForm.route;
                    ele.val(model.shippingAddress1);
                } else {
                    // No street number so just pull it from the field
                    model.shippingAddress1 = ele.val().split(',')[0];
                    model.address1 = ele.val().split(',')[0];
                }
                if (componentForm.locality !== 'long_name') {
                    model.shippingCity = componentForm.locality;
                    model.city = componentForm.locality;
                } else {
                    model.shippingCity = '';
                    model.city = '';
                    addressIncomplete = true;
                }

                if (componentForm.postal_code !== 'short_name' || componentForm.postal_code_prefix !== 'short_name') {
                    if (componentForm.postal_code !== 'short_name') {
                        model.shippingPostalCode = componentForm.postal_code;
                        model.paymentPostalCode = componentForm.postal_code;
                    } else if (componentForm.postal_code_prefix !== 'short_name') {
                        model.shippingPostalCode = componentForm.postal_code_prefix;
                        model.paymentPostalCode = componentForm.postal_code_prefix;
                    }
                } else {
                    model.shippingPostalCode = '';
                    model.paymentPostalCode = '';
                    addressIncomplete = true;
                }
                if (addressIncomplete) {
                    events.publish(events.errors.NUMBER_STREET_ADDRESS);
                }
                // this is to checkout the value against the display name of the county
                getCountyDropdownOptions(componentForm.administrative_area_level_2);

                if (isShippingForm === true) {
                    checkStateValidity('#new_form_shippingState', componentForm.administrative_area_level_1, "shipping", customer);
                } else if (isPaymentForm === true) {
                    checkStateValidity('#new_form_region', componentForm.administrative_area_level_1, "payment", customer);
                }

                scope.$apply();
            }

            function buildGoogleMapsScriptTag() {
                let script = document.createElement('script');
                script.setAttribute("src", "https://maps.googleapis.com/maps/api/js?key=" + mapsApiKey + "&libraries=places&callback=initAutocomplete");
                script.setAttribute("async", "async");
                script.setAttribute("defer", "defer");
                script.setAttribute("id", "googleApi");
                document.head.appendChild(script);
            }

            window.initAutocomplete();
        }
    }
}]);
